import _styled2 from "styled-components";
import _styled from "styled-components";
import React from 'react';
import { AlertBox } from '../alert-box/AlertBox';
import { SpinnerSize, Spinner } from '../spinner/Spinner';
import * as styles from './AsyncLoading.style';
export const DEFAULT_SPINNER_COLOR = 'neutrals.light';

/** @deprecated use skeleton instead */

export const AsyncLoading = _ref => {
  let {
    dataRef = 'async-loading',
    isLoading,
    errorMessage,
    spinnerSize,
    spinnerColor,
    renderErrorTemplate,
    placeholder,
    children
  } = _ref;
  if (isLoading) {
    return placeholder || /*#__PURE__*/React.createElement(_StyledDiv, {
      "data-ref": `${dataRef}-spinner`,
      $_css: styles.loading
    }, /*#__PURE__*/React.createElement(Spinner, {
      size: spinnerSize || SpinnerSize.MEDIUM,
      color: spinnerColor || DEFAULT_SPINNER_COLOR
    }));
  }
  if (errorMessage) {
    return /*#__PURE__*/React.createElement(_StyledDiv2, {
      "data-ref": `${dataRef}-error`,
      $_css2: styles.error
    }, renderErrorTemplate || /*#__PURE__*/React.createElement(AlertBox, {
      message: errorMessage
    }));
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement(React.Fragment, null, children)
  );
};
export default AsyncLoading;
var _StyledDiv = _styled("div").withConfig({
  displayName: "AsyncLoading___StyledDiv",
  componentId: "sc-38ol8j-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "AsyncLoading___StyledDiv2",
  componentId: "sc-38ol8j-1"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=AsyncLoading.js.map